import React, { useContext, useEffect, useState } from 'react';
import { Button, Modal } from '@material-ui/core';

import { logisticsApi } from 'api/logistics';
import { UserContext } from 'contexts/UserContext';
import { DataTable, Notifications } from 'shared';

function ResyncModal({ closeModal, hub, lineHaulID }) {
    return (
        <div>
            <Modal open onClose={closeModal}>
                <div>
                    <div
                        style={{
                            outline: 0,
                            backgroundColor: 'white',
                            width: '400px',
                            margin: '10% auto',
                            padding: '10px',
                        }}
                    >
                        You are about to re-sync {hub} ID {lineHaulID} to bring - Do you wish to proceed?
                        <div>
                            <Button
                                onClick={async () => {
                                    const res = await logisticsApi.resyncLineHaul(lineHaulID);
                                    console.log(res);
                                    if (res.status == false) {
                                        closeModal({ text: `Error re-syncing line haul: ${res.msg}`, level: 'error' });
                                        return;
                                    }
                                    closeModal({
                                        text: 'Successfully submitted re-synced line haul job. You will be emailed when the re-sync is complete',
                                        level: 'success',
                                    });
                                }}
                            >
                                Confirm
                            </Button>
                            <Button onClick={() => closeModal({})}>Cancel</Button>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
}
function ResyncLineHaul() {
    const user = useContext(UserContext);
    const [notification, setNotification] = useState({ text: null, level: null });
    const [showResyncModal, setShowResyncModal] = useState(false);
    const [modalParams, setModalParams] = useState({});
    const [rows, setRows] = useState([]);

    const getRecentLineHaulShippingDays = async () => {
        const response = await logisticsApi.getRecentLineHaulShippingDays(user.getFacilityID(), true);

        if (response.status === false) {
            setNotification({ text: 'Error getting recent shipping day: '.response.msg, level: 'error' });
            return;
        }

        setRows(response.data.rows);
    };

    useEffect(() => {
        getRecentLineHaulShippingDays();
    }, []);

    const columns = [
        { accessor: 'lineHaulID', Header: 'ID' },
        { accessor: 'hub', Header: 'Hub' },
        { accessor: 'preferredDay', Header: 'Preferred Day' },
        {
            accessor: 'resync',
            Header: 'Resync',
            Cell: ({ row }) => (
                <Button
                    onClick={() => {
                        setModalParams({
                            lineHaulID: row.original.lineHaulID,
                            preferredDay: row.original.preferredDay,
                            hub: row.original.hub,
                        });
                        setShowResyncModal(true);
                    }}
                >
                    Resync
                </Button>
            ),
        },
    ];

    return (
        <div>
            <Notifications options={notification} />
            {showResyncModal && (
                <ResyncModal
                    lineHaulID={modalParams.lineHaulID}
                    hub={modalParams.hub}
                    closeModal={(notificationPassback) => {
                        setModalParams({});
                        setShowResyncModal(false);
                        setNotification(notificationPassback);
                    }}
                />
            )}
            <DataTable columns={columns} data={rows} />
        </div>
    );
}

export { ResyncLineHaul };
